import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import { CDN_LINK } from "@globalConfig";
import stl from "./Pagination.module.css";
var Pagination = function Pagination(_ref) {
  var pageCount = _ref.pageCount,
    currentPage = _ref.currentPage,
    getPrePage = _ref.getPrePage,
    getPageByNumber = _ref.getPageByNumber,
    getNextPage = _ref.getNextPage;
  var _useState = useState(+currentPage),
    activePage = _useState[0],
    setActivePage = _useState[1];
  var _useState2 = useState(_toConsumableArray(Array(pageCount)).map(function (_, i) {
      return i + 1;
    }).splice(currentPage - 1, 5)),
    pagesToShow = _useState2[0],
    setPagesToShow = _useState2[1];
  var arrayOfPages = _toConsumableArray(Array(pageCount)).map(function (_, i) {
    return i + 1;
  });
  var handlePageClick = function handlePageClick(e) {
    getPageByNumber(e.target.innerText);
    setActivePage(+e.target.innerText);
  };
  var handlePrePage = function handlePrePage() {
    setActivePage(function (preActive) {
      return preActive - 1;
    });
    getPrePage();
  };
  var handleNextPage = function handleNextPage() {
    setActivePage(function (preActive) {
      return preActive + 1;
    });
    getNextPage();
  };
  useEffect(function () {
    var activePageIndex = pagesToShow.indexOf(activePage);
    if (activePageIndex >= pagesToShow.length - 2) {
      var arrayOfPagesCopy = _toConsumableArray(arrayOfPages);
      setPagesToShow(arrayOfPagesCopy.splice(activePage - 1, 5));
    }
  }, [activePage]);
  return /*#__PURE__*/React.createElement("div", {
    className: stl.pagination
  }, /*#__PURE__*/React.createElement("button", {
    className: [stl.prev, currentPage === 1 ? stl.disabled : ""].join(" "),
    onClick: handlePrePage
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/down-arrow.svg",
    alt: ""
  })), pagesToShow.map(function (item) {
    return /*#__PURE__*/React.createElement("button", {
      key: item,
      className: activePage === item ? stl.active : "",
      onClick: function onClick(e) {
        return handlePageClick(e);
      }
    }, item);
  }), /*#__PURE__*/React.createElement("button", {
    className: [stl.next, currentPage === pageCount ? stl.disabled : ""].join(" "),
    onClick: handleNextPage
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/down-arrow.svg",
    alt: ""
  })));
};
export default Pagination;